/**
 * Day / Week / Month segmented control for the comparison chart bucketing.
 * Self-contained (mirrors the flow-optimizer PillSegmentRow visual, no cross-import).
 * For Media Devoted | Created By Ciro Autiero
 */

import { cn } from '@/lib/utils';

import type { Granularity } from '../../data/types';

const OPTIONS: { value: Granularity; label: string }[] = [
  { value: 'day', label: 'Day' },
  { value: 'week', label: 'Week' },
  { value: 'month', label: 'Month' },
];

interface Props {
  value: Granularity;
  onChange: (value: Granularity) => void;
}

export function GranularitySegment({ value, onChange }: Props) {
  return (
    <div className="flex gap-1.5" role="radiogroup" aria-label="Chart granularity">
      {OPTIONS.map((opt) => {
        const selected = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={selected}
            onClick={() => onChange(opt.value)}
            className={cn(
              'rounded-full border px-3 py-1 text-xs font-semibold transition-colors',
              selected
                ? 'border-primary bg-primary/10 text-foreground ring-2 ring-primary/25'
                : 'border-border bg-muted/30 text-muted-foreground hover:bg-muted/50 hover:text-foreground',
            )}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}

export default GranularitySegment;
